export default "__VITE_ASSET__1e85bf71__"